import {
  DropDownList,
  DropDownListChangeEvent
} from '@progress/kendo-react-dropdowns';
import { GridFilterCellProps } from '@progress/kendo-react-grid';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  trueLabel?: string;
  falseLabel?: string;
  allLabel?: string;
}

type Option = {
  label: string;
  value: boolean | undefined;
};

export const BooleanFilterCell: React.FC<
  React.PropsWithChildren<Props & GridFilterCellProps>
> = ({ value, allLabel, trueLabel, falseLabel, onChange }) => {
  const { t } = useTranslation();
  const [options] = useState<Option[]>([
    {
      label: allLabel ?? t('props.all'),
      value: undefined
    },
    {
      label: trueLabel ?? t('props.active'),
      value: true
    },
    {
      label: falseLabel ?? t('props.inactive'),
      value: false
    }
  ]);

  const [currentValue, setCurrentValue] = useState<Option>(options[0]);

  const handleChange = (event: DropDownListChangeEvent) => {
    const { value }: Option = event.value;
    onChange({
      value: typeof value === 'boolean' ? value : '',
      operator: typeof value === 'boolean' ? 'eq' : '',
      syntheticEvent: event.syntheticEvent
    });
  };

  useEffect(() => {
    if (value === undefined || value === '') {
      setCurrentValue(options[0]);
    } else if (value) {
      setCurrentValue(options[1]);
    } else {
      setCurrentValue(options[2]);
    }
  }, [value, options]);

  return (
    <div className="k-filtercell">
      <DropDownList
        data={options}
        textField="label"
        value={currentValue}
        onChange={handleChange}
      />
    </div>
  );
};
